export class SourceManager {
  constructor() {
    this.value = null;
  }
  updateValue(value) {
    this.value = value

    window.dispatchEvent(new CustomEvent('source-update', { 
      bubbles: true, 
      detail: value 
    }));

    console.log("Source: " + value)
  }
  getValue(v) {

    if (!this.value) {
      return v;
    }

    return this.value
  }
}
